import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { UserModel } from '../../../user.model';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import {
    FiUserEditDataFieldName_Settings,
    FiUserEditDataFieldNameComponent,
    TFiUserEditDataFieldName_Settings,
} from '../../data-field/name.component';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { DataFieldEdit_ComponentTypeFactory } from '@fi-app/data-field/data-field-edit/data-field-edit.component';
import { DataFieldPropertyType } from '@fi-app/data-field/data-field-property-type';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserHelperService } from '@fi-shared/fi-user-shared/fi-user-helper.service';
import { FiUserSignInSettings } from '@fi-app/user/user-edit/fi-user-sign-in-settings';

@Component({
    selector: 'fi-user-edit-profile-information',
    templateUrl: './fi-user-edit-profile-information.component.html',
    styleUrls: ['./fi-user-edit-profile-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-edit-profile-information' },
    providers: [
        {
            provide: DataFieldEdit_ComponentTypeFactory,
            useFactory: () => (dataField: DataFieldModel) =>
                dataField.PropertyType === DataFieldPropertyType.Name ? FiUserEditDataFieldNameComponent : undefined,
        },
        {
            provide: FiUserEditDataFieldName_Settings,
            deps: [FiUserEditProfileInformationComponent],
            useFactory: (
                userEditComponent: FiUserEditProfileInformationComponent,
            ): TFiUserEditDataFieldName_Settings => {
                return {
                    isDisabledFunc: () => userEditComponent.isADLogin() || userEditComponent.isPKUser(),
                    LoginNameLabel: userEditComponent.appTextService.get('login.sign_in_email'),
                    fiUserSignInSettings: userEditComponent.fiUserSignInSettings,
                };
            },
        },
        { provide: FiComponentsContainer, useExisting: FiUserEditProfileInformationComponent },
    ],
    standalone: false,
})
export class FiUserEditProfileInformationComponent extends FiComponentsContainer {
    @Input() dataFields: DataFieldModel[] = [];
    @Input() user: UserModel;
    @Input() fiUserSignInSettings: FiUserSignInSettings;

    constructor(
        private customerDataService: FiCustomerDataService,
        private userHelperService: FiUserHelperService,
        private appTextService: AppTextService,
    ) {
        super();
    }

    isADLogin(): boolean {
        return this.customerDataService.isADLogin();
    }

    isPKUser(): boolean {
        return this.userHelperService.isPKUser(this.user);
    }
}
